export default "__VITE_ASSET__f75d4ce9__"